import { Link } from 'react-router-dom'
import { FileQuestion } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <FileQuestion className="mb-4 h-16 w-16 text-muted-foreground" />
      <h1 className="text-4xl font-bold">404</h1>
      <p className="mt-2 text-lg text-muted-foreground">
        Pagina niet gevonden
      </p>
      <p className="mt-1 text-sm text-muted-foreground">
        De pagina die je zoekt bestaat niet of is verplaatst.
      </p>
      <Link to="/" className="mt-6">
        <Button>Terug naar dashboard</Button>
      </Link>
    </div>
  )
}
